// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentTypes, InstrumentTypesColor, getInstrumentTypeShortName, getVisualInstrumentType } from '@shared/utils/Instruments/InstrumentTypes';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
export class SymbolLookupViewItemHelper {
    static getInstrumentTypeShortForInstrument(instrument) {
        const instrumentType = getVisualInstrumentType(instrument.getType(), instrument.isCFD());
        return getInstrumentTypeShortName(instrumentType);
    }
    static getInstrumentTypeShort(type) {
        return type === InstrumentTypes.SPOT
            ? InstrumentUtils.UseFuturesInsteadSpotShortName()
            : getInstrumentTypeShortName(type);
    }
    static getInstrumentTypeColorForInstrument(instrument) {
        const instrumentType = getVisualInstrumentType(instrument.getType(), instrument.isCFD());
        return InstrumentTypesColor[instrumentType];
    }
    static getInstrumentTypeColor(type) {
        return type === InstrumentTypes.SPOT
            ? InstrumentUtils.UseFuturesInsteadSpotColor()
            : InstrumentTypesColor[type];
    }
}
